import { gql } from "@apollo/client";
import { CategoryNoNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const QueryCategories = gql`
  ${CategoryNoNestingFragment}
  query QueryCategories($options: CategoryListOptions) {
    categories(options: $options) {
      items {
        ...CategoryNoNesting
      }
    }
  }
`;

export const DEFAULT_CATEGORIES_OPTIONS = {
  limit: 10,
  page: 1,
  includeDeleted: false,
  sort: { name: "ASC" },
};
